import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { login } from "./store/slices/auth.slice";
import AppRouter from "./router/AppRouter";
import { addServices } from "./store/slices/services.slice";
import { $GET } from "./api";
import Router from "./const/router";
import { setIsLoading, setLoading } from "./store/slices/general.slice";
import { addWorks } from "./store/slices/works.slice";
import { addSkills } from "./store/slices/skills.slice";
import Loader from "./components/Loader";
// Assets
// Services
import frontIcon from "./assets/server/front.png";
import backIcon from "./assets/server/back.png";
// Works
import geekerIcon from "./assets/server/geeker.jpeg";
import innovaIcon from "./assets/server/innova.png";
import nftPicture from "./assets/server/nft-picture.jpg";
// Skills
import jsIcon from "./assets/server/js.png";
import tsIcon from "./assets/server/ts.png";
import nodeIcon from "./assets/server/node.png";
import reactIcon from "./assets/server/react.png";
import reduxIcon from "./assets/server/redux.png";
import htmlIcon from "./assets/server/html.png";
import cssIcon from "./assets/server/css.png";
import scssIcon from "./assets/server/scss.png";
import mysqlIcon from "./assets/server/mysql.png";
import postgresqlIcon from "./assets/server/postgresql.png";
import mongoIcon from "./assets/server/mongo.png";
import githubIcon from "./assets/server/github.png";
import gitIcon from "./assets/server/git.png";

const App = () => {
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.general);
  useEffect(() => {
    if (localStorage.getItem("token")) {
      dispatch(login());
    }
  }, []);

  useEffect(() => {
    const getAll = async () => {
      dispatch(setIsLoading(true));
      try {
        // const { data: services } = await $GET(Router.SERVICES);
        dispatch(
          addServices([
            {
              id: "63aebc881d5a6fbe8c1a7273",
              name: "Back-End",
              image_url: backIcon,
              description: "Using Node.js and Express.js.",
            },
            {
              _id: "63c6d6f147facdd20994b04f",
              name: "Front-End",
              image_url: frontIcon,
              description: "Using React.js and Typescript.",
            },
          ])
        );
        // const { data: works } = await $GET(Router.WORKS);
        dispatch(
          addWorks([
            {
              _id: "63ade8041ab6bc5b887994ee",
              title: "Geeker Project",
              image_url: geekerIcon,
              description: "I wrote the backend of this project.",
              deployed_url: "https://geeker.am/",
            },
            {
              _id: "63af52a11072f62d66d84aa3",
              title: "Innova IT School Website",
              image_url: innovaIcon,
              description:
                "I wrote the Back-End of this project, using Node.js and Express JS.",
              deployed_url: "https://test-rose-chi-17.vercel.app",
            },
            {
              _id: "63af52a110asfd9884aa3",
              title: "NFT Marketplace",
              image_url: nftPicture,
              description:
                "I wrote using React.js and Redux.",
              deployed_url: "https://nft-jshayk.vercel.app/",
            },
          ])
        );
        // const { data: skills } = await $GET(Router.SKILLS);
        dispatch(
          addSkills([
            {
              _id: "63af4deb1072f62d66d845bb",
              name: "React JS",
              image_url: reactIcon,
            },
            {
              _id: "63af4e281072f62d66d845fe",
              name: "Redux",
              image_url: reduxIcon,
            },
            {
              _id: "63af4e4f1072f62d66d84629",
              name: "HTML",
              image_url: htmlIcon,
            },
            {
              _id: "63af4e671072f62d66d84645",
              name: "CSS",
              image_url: cssIcon,
            },
            {
              _id: "63af4e831072f62d66d84664",
              name: "SCSS",
              image_url: scssIcon,
            },
            {
              _id: "63af4eaf1072f62d66d84695",
              name: "TypeScript",
              image_url: tsIcon,
            },
            {
              _id: "63af4eef1072f62d66d846d8",
              name: "Node.js",
              image_url: nodeIcon,
            },
            {
              _id: "63af4f101072f62d66d846fd",
              name: "Git",
              image_url: gitIcon,
            },
            {
              _id: "63af4f291072f62d66d84719",
              name: "GitHub",
              image_url: githubIcon,
            },
            {
              _id: "63af51701072f62d66d84964",
              name: "MySql",
              image_url: mysqlIcon,
            },
            {
              _id: "63af51a11072f62d66d8499a",
              name: "PostgreSQL",
              image_url: postgresqlIcon,
            },
            {
              _id: "63af51b71072f62d66d849b3",
              name: "MongoDB",
              image_url: mongoIcon,
            },
            {
              _id: "63bf0d27325a0fb1e339baa4",
              name: "JavaScript",
              image_url: jsIcon,
            },
          ])
        );
      } catch (err) {
        throw new Error(err.message);
      }
      dispatch(setIsLoading(false));
    };
    getAll();
  }, []);
  return <>{isLoading ? <Loader /> : <AppRouter />}</>;
};

export default App;
